import React, { useState} from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Button, TextArea, Loader, Dimmer, Card } from "semantic-ui-react";
import APIService from "../../Services/API/APIService";
import FileUpload from "./ImageUpload";
import { toast } from "react-toastify";
import { useAuth } from "../../Context/AppContext";

const GuestHouseProduct = (mainprops) => {

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const { user } = useAuth();
  const isSuperAdmin = user?.group?.[0] === "SUPERADMIN";


  const schema = Yup.object().shape({
    name: Yup.string().required("Required"),
    price: Yup.number().required("Required"),
    description: Yup.string().required("Required"),
    totalRooms : Yup.number().required("Required"),
    locationId: isSuperAdmin
      ? Yup.number().oneOf([1, 2], "Select a valid location").required("Location is required")
      : Yup.mixed(),

  });

  const newItem = {
    name: "",
    price: "",
    description: '',
    totalRooms : '',
    locationId: ''
  };

  const _saveData = async (values) => {
    //console.log("values", values);


    try {
      setLoading(true);

      let formData = new FormData();

      files.forEach((file, index) => {
        formData.append(`photos`, file);
      });

      //Stringify this or experience pain
      formData.append("values", JSON.stringify(values));
      await APIService.postFormData("/guest-house/savePackage", formData);
      mainprops.togglePackageModal(false)

    } catch (error) {
      
      setLoading(false);
      toast.warn(error)
    }
  };

  return (
    <div>
      <Card fluid>
        {loading && (
          <Dimmer active inverted>
            <Loader > Uploading Please wait...  </Loader>
          </Dimmer>
        )}
        <Card.Content>
          <Formik
            loading={loading}
            enableReinitialize={true}
            initialValues={mainprops.package || newItem}
            validationSchema={schema}
            onSubmit={_saveData}
          >
            {(props) => {
              const { values, touched, errors, handleChange, handleSubmit, setFieldValue } = props;
              return (
                <Form onSubmit={handleSubmit}>
                  {/* {JSON.stringify(values,null,2)} */}
                  {/* {JSON.stringify(errors,null,2)} */}

                  <Form.Group widths={3}>
                    <Form.Input
                      label="Name"
                      placeholder="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      error={touched.name && errors.name}
                    />

                    <Form.Input
                      label="Price"
                      placeholder="Price"
                      name="price"
                      type='number'
                      value={values.price}
                      onChange={handleChange}
                      error={touched.price && errors.price}
                    />

                    <Form.Input
                      label="Total Rooms"
                      placeholder="Total Rooms"
                      name="totalRooms"
                      type='number'
                      value={values.totalRooms}
                      onChange={handleChange}
                      error={touched.totalRooms && errors.totalRooms}
                    />

                  </Form.Group>

                  {isSuperAdmin && (
                    <Form.Field error={touched.locationId && Boolean(errors.locationId)}>
                      <label>Location</label>
                      <Form.Group grouped>
                        <Form.Radio
                          label="Lagos"
                          name="locationId"
                          value={1}
                          checked={Number(values.locationId) === 1}
                          onChange={(_, data) => setFieldValue("locationId", data.value)}
                        />
                        <Form.Radio
                          label="Port Harcourt"
                          name="locationId"
                          value={2}
                          checked={Number(values.locationId) === 2}
                          onChange={(_, data) => setFieldValue("locationId", data.value)}
                        />
                      </Form.Group>
                      {touched.locationId && errors.locationId && (
                        <div className="ui pointing red basic label">{errors.locationId}</div>
                      )}
                    </Form.Field>
                  )}

                  <Form.Field>
                    <label>Description</label>
                    <TextArea
                      rows={4}
                      placeholder="description"
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      error={touched.description && errors.description}
                    />


                  </Form.Field>


                  <FileUpload
                    files={files}
                    setFiles={setFiles}
                    images={mainprops}

                  />



                  <Button
                    style={{ backgroundColor: '#26f09e', color: '#000000' }}
                    icon="checkmark"
                    labelPosition="right"
                    content="Save Room"
                    type="submit"
                  />
                </Form>
              );
            }}
          </Formik>
        </Card.Content>
      </Card>
    </div>
  );
};

export default GuestHouseProduct;
